import {Theme} from "@emotion/react";
import {Stack, SxProps, Typography} from "@mui/material";
import {useThemeContext} from "@theme";
import {isToday} from "date-fns";
import dayjs from "dayjs";
import {View} from "react-big-calendar";

const Day = ({
  minimize = false,
  date,
  view,
  sx,
}: {
  date: Date;
  view: View;
  minimize?: boolean;
  sx?: SxProps<Theme>;
}) => {
  const highlight = isToday(date);
  const {onPrimary} = useThemeContext();
  const d = dayjs(date);

  const highlightSx: SxProps<Theme> = {
    borderRadius: "50%",
    width: 32,
    bgcolor: "primary.dark",
    color: onPrimary,
  };

  if (view === "week") {
    return (
      <Stack className="agenda-row-day" sx={sx}>
        <Typography
          color="textPrimary"
          variant="caption"
          textTransform={"capitalize"}>
          {d.format("ddd")}
        </Typography>
        <Typography
          variant="h6"
          color="textPrimary"
          textTransform={"capitalize"}
          sx={highlight ? highlightSx : undefined}>
          {d.format("DD")}
        </Typography>
      </Stack>
    );
  }

  if (view === "agenda") {
    return (
      <Stack
        className="agenda-row-day"
        sx={sx}
        direction={"column"}
        width={minimize ? 60 : 130}
        px={1}
        justifyContent={"center"}
        bgcolor={highlight ? "secondary.dark" : "primary.dark"}>
        {minimize && (
          <Stack
            className="agenda-row-day"
            pt={1}
            alignItems={"center"}
            justifyContent={"start"}>
            <Typography
              color={onPrimary}
              variant="caption"
              textTransform={"uppercase"}
              lineHeight={1}>
              {d.format("ddd")}
            </Typography>
            <Typography
              color={onPrimary}
              textAlign={"center"}
              variant="h6"
              textTransform={"uppercase"}
              lineHeight={1.5}>
              {d.format("DD")}
            </Typography>
            <Typography
              color={onPrimary}
              variant="caption"
              textTransform={"capitalize"}
              lineHeight={1}>
              {d.format("MMM")}
            </Typography>
          </Stack>
        )}
        {!minimize && (
          <Stack
            className="agenda-row-day"
            direction={"row"}
            gap={1}
            alignItems={"flex-end"}
            height={26}>
            <Typography
              color={onPrimary}
              textAlign={"center"}
              variant="h6"
              textTransform={"uppercase"}
              lineHeight={1}>
              {d.format("DD")}
            </Typography>
            <Typography
              color={onPrimary}
              variant="caption"
              textTransform={"uppercase"}
              lineHeight={1.3}>
              {d.format("ddd")}, {d.format("MMM")}
            </Typography>
          </Stack>
        )}
      </Stack>
    );
  }

  return (
    <Stack className="agenda-row-day" sx={sx}>
      <Typography
        color="textPrimary"
        variant="caption"
        textTransform={"uppercase"}>
        {d.format("ddd")}
      </Typography>
    </Stack>
  );
};

export {Day};
